import React from 'react';
import { Theme } from '@material-ui/core';
import {
  makeStyles,
  createStyles,
} from '@material-ui/styles';
import { Button } from '..';
import Link from '../link/Link';
import logoDefault from '../../assets/img/ph/logo-text-blue.svg';
import { Links } from '../../utility/links';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'center',
    width: '100%',
    padding: 0,
  },
  logo: {
    width: '120px',
    height: '40px',
  },
  cropLogo: {
    width: 120,
    height: 40,
    margin: '-11px',
    overflow: 'hidden',
  },
  link: {
    color: palette.publicNavBar.color,
    margin: '0 20px',
    fontSize: '14px',
    fontFamily: 'Montserrat, sans',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'none',
      color: palette.publicNavBar.hover,
    },
    '&:active': {
      color: palette.publicNavBar.active,
    },
  },
  grow: {
    flexGrow: 1,
  },
  button: {
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: 'Montserrat, sans',
    fontWeight: 600,
    padding: '5px 20px',
    margin: '0 20px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  lastButton: {
    marginRight: 0,
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
}), { name: 'PagesMainBarContentLg' });

const PagesMainBarContentLg = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Link to="/">
        <div className={classes.cropLogo}>
          <img
            src={logoDefault}
            alt="pitchhub logo"
            className={classes.logo}
          />
        </div>
      </Link>
      <Link to="/pages/pricing" className={classes.link}>
        Pricing
      </Link>
      <div className={classes.grow} />
      <Link to={Links.support} defaultAction target="_blank" className={classes.link}>
        Support
      </Link>
      <Link to={Links.blog} defaultAction target="_blank" className={classes.link}>
        Blog
      </Link>
      <Link to="/pages/login" className={classes.link}>
        Log In
      </Link>
      <Link to="/pages/register" className={classes.buttonLink}>
        <Button
          color="primary"
          variant="contained"
          className={`${classes.button} ${classes.lastButton}`}
        >
          Try for free!
        </Button>
      </Link>
    </div>
  );
};

export default PagesMainBarContentLg;
